// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f1374508","977":"c6445990"}[chunkId] + ".chunk.js";
};